import { css } from '@emotion/react';

import { getTheme } from 'src/utils/getTheme';

const { theme, isHosTheme } = getTheme();

export const styles = {
    roommateDetailsContainer: css({
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
    }),

    inputGroupWrapper: css({
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        [theme.breakpoints.up('lg')]: {
            flexDirection: 'row',
        },
    }),

    roommateHeader: css({
        margin: '40px 0',
    }),

    email: css({
        marginTop: '20px',
    }),

    cta: css({
        borderRadius: '100px',
        paddingBlock: '16px',
        width: isHosTheme ? '390px' : '100%',
        marginTop: isHosTheme ? '20px' : '0',
    }),
};
